import CsvIcon from "../ui/icons/CsvIcon";
import PdfIcon from "../ui/icons/PdfIcon";
import { cn } from "@/lib/utils";
import { Text } from "../ui/text";
import CloseIcon from "../ui/icons/CloseIcon";

const UploadErrorIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM11 13H13V7H11V13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="#FF4E57"/>
  </svg>
);

type Props = {
  id: number;
  type: "pdf" | "csv" | "image";
  fileName: string;
  imageUrl: string;
  onRemove?: (id: number) => void;
  hasError?: boolean;
};

const AttachBox = ({
  id,
  fileName = "tedsadsadasdsadsadast.csv",
  type = "image",
  imageUrl,
  onRemove,
}: Props) => {
  const handleRemove = () => {
    if (onRemove) {
      onRemove(id);
    }
  };
  if (type === "image") {
    return (
      <article className="bg-red-0 relative group flex items-center h-[60px] w-[60px] rounded-lg">
        <img
          src={imageUrl}
          alt="image"
          className="w-full h-full object-cover"
        />
        {hasError && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/20 rounded-lg">
            <UploadErrorIcon />
          </div>
        )}
        {onRemove && (
          <button
            onClick={handleRemove}
            className="opacity-0 group-hover:opacity-100 transition-opacity absolute right-0 top-0 w-[60px] h-[60px] flex justify-center items-center bg-white/30"
          >
            <CloseIcon />
          </button>
        )}
      </article>
    );
  }

  return (
    <article className="relative group flex items-center h-[60px] w-[212px] gap-[10px] pl-2 pr-3 bg-white rounded-lg">
      <div
        className={cn(
          "w-[40px] h-[40px] rounded-lg flex justify-center items-center",
          type === "pdf" && "bg-red-30",
          type === "csv" && "bg-primary-40"
        )}
      >
        {type === "pdf" && <PdfIcon />}
        {type === "csv" && <CsvIcon />}
      </div>
      <div className="flex flex-col">
        <div className="w-[142px] truncate overflow-hidden whitespace-nowrap">
          <Text variant="body-md" className="text-grey-20">
            {fileName}
          </Text>
        </div>
        <Text variant="body-md" className="text-grey-60">
          {type === "pdf" ? "PDF" : "CSV"}
        </Text>
      </div>
      {onRemove && (
        <button
          onClick={handleRemove}
          className="opacity-0 group-hover:opacity-100 transition-opacity absolute right-0 top-[10px] w-[40px] h-[40px] flex justify-center items-center bg-white"
        >
          <CloseIcon />
        </button>
      )}
    </article>
  );
};

export default AttachBox;
